import React from "react";
import "./style.css";
import Gauge from './gauge.tsx';
import _ from 'lodash';
import moment from 'moment';


function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = React.useState(value);
  React.useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}


export default function App() {
  const currentRef = React.useRef();
  const timeRef = React.useRef();
  const [error, setError] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [allFlightsTotal, setAllFlightsTotal] = React.useState(0);
  const [now, setNow] = React.useState(0);
  const [nowText, setNowText] = React.useState('');
  const [laterText, setLaterText] = React.useState('');
  const [nowLevel, setNowLevel] = React.useState(0);
  const [time, setTime] = React.useState(0);
  const [level, setLevel] = React.useState(0);
  const [all, setAll] = React.useState([]);
  const [numOfFlights, setNumOfFlights] = React.useState(0);
  const [flights, setFlights] = React.useState([]);
  const [range, setRange] = React.useState('');
  const [color, setColor] = React.useState('stroke-sky-700');
  const [loading, setLoading] = React.useState(false);
  const [terminal, setTerminal] = React.useState();
  const [preArrival, setPreArrival] = React.useState('בין 2 ל 3 ');
  // const [amazoneScript, setAmazonScript] = React.useState('<script type="text/javascript">amzn_assoc_tracking_id = "tlvport-20";amzn_assoc_ad_mode = "manual";amzn_assoc_ad_type = "smart";amzn_assoc_marketplace = "amazon";amzn_assoc_region = "US";amzn_assoc_design = "enhanced_links";amzn_assoc_asins = "B084YXHFCL";amzn_assoc_placement = "adunit";amzn_assoc_linkid = "7a2fac09f936e5867cd3145438808bf5";</script><script src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US"></script>');
  const debouncedTime = useDebounce(time, 500);

  const USE_CLIENT_CALC = true;
  const cache = React.useRef();

  const toggleTerminal = React.useCallback(() => {
    setTerminal(terminal => terminal === 3 ? 1 : 3);
  }, []);


  React.useEffect(() => {
    timeRef.current.value = moment(new Date(), "HH:mm Z").format("HH:mm")
    currentRef.current = timeRef.current.value;
  }, []);

  const onLoad = React.useCallback(() => {
    fetch('https://eozcw704t8ln4z9.m.pipedream.net')
      .then(r => r.json())
      .then(r => {
        cache.current = r;
        let noCanceld = (cache.current ?? []).filter(p => p.Remarks !== 'מבוטלת').filter(r => r.Terminal == terminal);
        const noCodeShare = noCanceld.reduce((previousValue, currentValue) => {
          return _.find(previousValue, function (o) { return o.Time === currentValue.Time && o.Location === currentValue.Location }) ? previousValue : previousValue.concat(currentValue)
        }, []);

        const allFlightsTotal = noCodeShare.reduce((all, current) => {
          return all + _.toNumber(current?.extraData[3]?.replace(/[^0-9.]/g, '') ?? 120)
        }, 0);
        setAllFlightsTotal(allFlightsTotal);
        setAll(r);
        setTime(timeRef.current.value);
        setNow(currentRef.current);
        setTerminal(3);
      }).catch(e => {
        setError(isErr => !isErr);
        setLoading(false);
      })
    setLoading(true);
  }, []);

  React.useEffect(() => {
    setTime(timeRef.current.value);
    setNow(currentRef.current);
  }, [terminal]);

  React.useEffect(() => {
    onLoad();
  }, []);


  const clientCalc = React.useCallback((start, end, terminal, moment) => {
    return new Promise((resolve, reject) => {

      let noCanceld = (cache.current ?? []).filter(p => p.Remarks !== 'מבוטלת').filter(r => r.Terminal == terminal);

      const noCodeShare = noCanceld.reduce((previousValue, currentValue) => {
        return _.find(previousValue, function (o) { return o.Time === currentValue.Time && o.Location === currentValue.Location }) ? previousValue : previousValue.concat(currentValue)
      }, []);

      const allFlightsTotal = noCodeShare.reduce((all, current) => {
        return all + (current?.extraData[3]?.replace(/[^0-9.]/g, '') ? _.toNumber(current?.extraData[3]?.replace(/[^0-9.]/g, '')) : 120)
      }, 0);
      setAllFlightsTotal(allFlightsTotal);

      const calcByTime = _.groupBy(noCodeShare, t => moment(t.Time).isBetween(moment(t.Time.split('T')[0] + `T${start}`, "YYYY-MM-DD HH:mm:ss"), moment(t.Time.split('T')[0] + `T${end}`, "YYYY-MM-DD HH:mm:ss")))
      calcByTime[true] = (calcByTime[true] ?? []).map(r => {
        return { ...r, seats: r?.extraData[3]?.replace(/[^0-9.]/g, '') ? _.toNumber(r?.extraData[3]?.replace(/[^0-9.]/g, '')) : 120 };
      });

      const total = (calcByTime[true] ?? []).reduce((all, current) => {
        return all + (current?.extraData[3]?.replace(/[^0-9.]/g, '') ? _.toNumber(current?.extraData[3]?.replace(/[^0-9.]/g, '')) : 120)
      }, 0);
      setTotal(total);
      // const flightsInTime1 =calcByTime[true].reduce((previousValue, currentValue) =>  {
      //   console.log(currentValue?.extraData[3]);
      //   return previousValue + Number(currentValue?.extraData[3]? currentValue?.extraData[3].replace('\n','') : 0);
      // }, 0);
      setTimeout(() => {
        resolve({ ...calcByTime, flightsInTime: calcByTime[true] });
      }, 0);
    });
  }, []);


  React.useEffect(() => {
    let start = moment.utc(time, "HH:mm Z").subtract(30, 'minutes').format("HH:mm");
    let end = moment.utc(time, "HH:mm Z").add(30, 'minutes').format("HH:mm");
    if (moment.utc(time, "HH:mm Z").add(30, 'minutes').format("HH") === '00') {
      end = '23:59';
    }
    setLoading(true);
    const s = () => true ? clientCalc(start, end, terminal, moment) : fetch(`https://eozcw704t8ln4z9.m.pipedream.net?start=${start}&end=${end}&terminal=${terminal}`)
    s().then(r => {
      const flights = r[true]?.length ?? 0;
      const numOfFlights = r.flightsInTime?.length ?? 0;
      setNumOfFlights(numOfFlights);
      setFlights(r[true]);
      setRange(`${start} - ${end}`);
      switch (true) {
        case terminal === 3 ? numOfFlights <= 7 : numOfFlights <= 3:
          setPreArrival('בין 2 ל 3');
          setLevel(20);
          setColor('stroke-green-400');
          setLaterText('');
          break;
        case terminal === 3 ? numOfFlights > 7 && numOfFlights < 15 : numOfFlights > 3 && numOfFlights < 7:
          setLevel(50);
          setPreArrival('בין 2 ל 3');
          setColor('stroke-yellow-500');
          setLaterText('עומס קל, צ׳ק-אין כ-30 דקות, ביטחון כבודת יד כ45 דקות');
          break;
        case terminal === 3 ? numOfFlights >= 15 && numOfFlights < 25 : numOfFlights >= 7 && numOfFlights < 15:
          setPreArrival('בין 3 ל 3 וחצי');
          setLevel(80);
          setColor('stroke-red-600');
          setLaterText('עומס בינוני, צ׳ק-אין כ-45 דקות, ביטחון כבודת יד כ60 דקות');
          break;
        case terminal === 3 ? numOfFlights >= 25 : numOfFlights >= 15:
          setLevel(100);
          setPreArrival('בין 3 וחצי ל 4');
          setColor('stroke-red-700');
          setLaterText('עומס כבד, צ׳ק-אין כ-60 דקות, ביטחון כבודת יד כ90 דקות');
          break;
      }
    }).catch(e => { alert('אופס, מביך.. משהו השתבש'); setLoading(false); });
  }, [debouncedTime, terminal]);



  React.useEffect(() => {
    let start = moment.utc(currentRef.current, "HH:mm Z").add(3, 'hours').format("HH:mm");
    let end = moment.utc(currentRef.current, "HH:mm Z").add(4, 'hours').format("HH:mm");
    if (moment.utc(currentRef.current, "HH:mm Z").add(4, 'hours').format("HH") === '00') {
      end = '23:59';
    }
    const s = () => true ? clientCalc(start, end, terminal, moment) : fetch(`https://eozcw704t8ln4z9.m.pipedream.net?start=${start}&end=${end}&terminal=${terminal}`).then(r => r.json())
    s().then(r => {
      setLoading(false);
      const flights = r[true]?.length ?? 0;
      const numOfFlights = r.flightsInTime?.length ?? 0;
      switch (true) {
        case terminal === 3 ? numOfFlights <= 7 : numOfFlights <= 3:
          setNowLevel('#47c347');
          setNowText('אין עומס');
          break;
        case terminal === 3 ? numOfFlights > 7 && numOfFlights < 15 : numOfFlights > 3 && numOfFlights < 7:
          setNowLevel('#b5af1e');
          setNowText('עומס קל, צ׳ק-אין כ-30 דקות, ביטחון כבודת יד כ45 דקות');
          break;
        case terminal === 3 ? numOfFlights >= 15 && numOfFlights < 25 : numOfFlights >= 7 && numOfFlights < 15:
          setNowLevel('orange');
          setNowText('עומס בינוני, צ׳ק-אין כ-45 דקות, ביטחון כבודת יד כ60 דקות');
          break;
        case terminal === 3 ? numOfFlights >= 25 : numOfFlights >= 15:
          setNowLevel('#c3a247');
          setNowText('עומס כבד, צ׳ק-אין כ-60 דקות, ביטחון כבודת יד כ90 דקות');
          break;
      }
    }).catch(e => { alert('אופס, מביך.. משהו השתבש'); setLoading(false); });
  }, [now, terminal]);


  React.useEffect(() => {
    if (all.length > 0) {
      setLoading(false);
    }
  }, [range, flights, numOfFlights, all])

  return (
    <div dir="rtl" className="relative flex md:min-h-screen flex-col justify-center overflow-hidden bg-gray-50 sm:py-0 md:py-6">
      <div className="relative bg-white md:px-6 sm:px-2 md:pt-4 pb-8 md:shadow-xl sm:shadow-none ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10 w-full">
        <div className="mx-auto max-w-md px-4">

          {loading && (<div className="grid absolute w-full h-full bg-blue items-center text-center bg-white" style={{ backdropFilter: 'blur(5px)', opacity: 0.9, top: 0, left: 0, right: 0, bottom: 0, margin: 'auto', zIndex: 9999 }}>
            <div className="absolute top-60 left-0 right-0 animate-pulse">

              <div class="scene">
                <span class="cloud cloud--small"></span>
                <svg xmlns="http://www.w3.org/2000/svg" id="plane" class="plane" viewBox="0 0 104 47" x="0" y="0" width="104" height="47" background-color="#ffffff00">
                  <g id="avion">
                    <path d="M20 36C25 38 69 43 80 40 92 38 106 33 104 21 103 13 95 13 90 9 85 5 79 2 76 1 70-1 65 0 60 2 57 3 25 14 23 13 21 12 12 2 9 3 5 4 1 5 1 6 2 7 15 34 20 36Z" fill="#0085b2" />
                    <path d="M23 36C28 37 69 43 80 40 88 38 98 34 102 29 82 32 22 36 23 36Z" stroke="#ffffff00" stroke-width="1" fill="#14647f" />
                    <path d="M42 39C48 40 60 40 67 40 71 32 72 26 72 26L44 29C44 29 44 35 42 39Z" stroke="#ffffff00" stroke-width="1" fill="#0c3b4d" />
                    <path d="M7 16C7 16 9 20 10 22 13 27 16 13 16 13L7 16Z" stroke="#ffffff00" stroke-width="1" fill="#0c3b4d" />
                    <path d="M40 29C40 29 41 34 34 42 27 51 48 46 58 39 74 28 72 25 72 25L40 29Z" stroke="#ffffff00" stroke-width="1" fill="#006e96" />
                    <path d="M5 14C5 14 6 15 3 19 1 22 10 20 13 17 19 11 17 11 17 11L5 14Z" stroke="#ffffff00" stroke-width="1" fill="#006e96" />
                    <path d="M90 10C88 8 83 4 80 3 78 3 68 7 68 8 70 12 80 8 90 10Z" stroke="#ffffff00" stroke-width="1" fill="#0c3b4d" />
                    <path d="M89 9C87 7 82 3 79 2 77 2 67 6 67 7 69 11 79 7 89 9Z" stroke="#ffffff00" stroke-width="1" fill="#afe2ff" />
                  </g>
                </svg>
                <span class="cloud cloud--medium"></span>
                <span class="cloud cloud--large"></span>
              </div>

            </div>
          </div>)}

          {error && (<div className="text-center">אופס, מביך.. משהו השתבש</div>)}

          {!error && (
          <div className="divide-y divide-gray-500/50">
            <h1 className="text-xl">מד עומס יומי
              <button onClick={toggleTerminal} class="mx-2 px-4 font-semibold text-sm bg-cyan-500 text-white rounded-full shadow-sm">טרמינל {terminal}</button>
            </h1>
            <div className="text-center" style={{color: nowLevel}}>
              {nowText !== '' ?  `כרגע ${nowText}` : ''}
              {/* <br/> */}
              {/* כ {allFlightsTotal}  נוסעים ב {cache.current?.length} טיסות */}
            </div>



            <div className="space-y-6 py-8 text-base leading-7 text-gray-600">
              <div>
                כמה עמוס נתב״ג בזמן הטיסה שלי?
                <div className="text-xs">
                  נתוני טיסה קיימים בטווח השעות
                  <br />
                  {all.length > 0 ? `(${new Date(all[0]?.Time ?? 0).toLocaleString('he-il')}) עד (${new Date(all[all.length - 1]?.Time ?? 0).toLocaleString('he-il')})` : 'טוען נתוני טיסות ...'}
                </div>
              </div>


              <div className="grid grid-cols-3 grid-rows-1 gap-2" style={{ gridTemplateColumns: '0.4fr 0.4fr 0.3fr' }}>
                <div>זמן עלייה למטוס:</div>
                <div>

                  <div date-rangepicker class="flex items-center">
                    <div class="relative">
                      <input class="bg-gray-100 border border-gray-600 rounded-lg pl-5 p-2.5 py-2.5" disabled={all.length === 0} onChange={ev => setTime(ev.target.valueAsDate)} type="time" ref={timeRef} />
                      <div id="time-indicator" class="flex absolute inset-y-0 right-2 items-center pointer-events-none">
                        <svg aria-hidden="true" class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                      </div>
                    </div>
                  </div>

                </div>
                <div style={{ marginTop: '1px' }}>{range.indexOf('Invalid date') > -1 ? '' : range}</div>
              </div>

              <ul className="space-y-4">
                <li className="flex items-center">
                  <svg className={`ml-5 h-6 w-6 flex-none fill-sky-100 ${color} stroke-2`} stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="11" />
                    <path d="m8 13 2.165 2.165a1 1 0 0 0 1.521-.126L16 9" fill="none" />
                  </svg>

                  <p className="ml-4">
                    {laterText !== '' &&
                      <strong>
                        {laterText},&nbsp;
                      </strong>
                    }
                    {/* <div>כ <strong>{total}</strong> נוסעים  צפויים להתייצב לטיסות בשעה זו</div> */}
                      מומלץ להגיע לשדה {preArrival} שעות לפני ההמראה
                    הטיסה שלך מצטרפת לעוד <strong>{numOfFlights}</strong> טיסות בטווח זמן העלייה למטוס
                    
                  </p>
                </li>

              </ul>

              <div className="m-auto text-center" style={{ width: '145px' }}>
                <Gauge value={level} />
              </div>

              {/* <div className="text-center">
            <button onClick={() => {}} class="mx-2 px-4 font-semibold text-sm bg-cyan-500 text-white rounded-full shadow-sm">יש לי עידכון מהשדה</button>
          </div>

          <div className="grid gap-4 grid-cols-10">
            <button onClick={() => {}} class="font-semibold text-sm bg-green-200 text-black rounded shadow-sm">1</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-green-300 text-black rounded shadow-sm">2</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-green-500 text-black rounded shadow-sm">3</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-yellow-200 text-black rounded shadow-sm">4</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-yellow-300 text-black rounded shadow-sm">5</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-orange-200 text-black rounded shadow-sm">6</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-orange-300 text-black rounded shadow-sm">7</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-orange-500 text-black rounded shadow-sm">8</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-red-500 text-black rounded shadow-sm">9</button>
            <button onClick={() => {}} class="font-semibold text-sm bg-red-600 text-black rounded shadow-sm">10</button>
          </div> */}

              <p className="pt-10">
                <strong>
                  איך מתבצע החישוב?
                </strong>
                <br />
                העומס מושפע מגורמים רבים, 
                כמו מספר בודקים, אירועים חריגים המשפיעים על אורך התורים, מספר הטיסות ויעדן, המידע בגדר המלצה בלבד, והמצב בפועל יכול להשתנות:
              </p>
            </div>
          </div>
          )}

        </div>

        {/* <div dangerouslySetInnerHTML={{__html: amazoneScript}}/> */}

        <div className="relative">
          {flights?.length > 0 && (
            <div class="overflow-x-auto relative">
              <table className="w-full text-sm text-left text-gray-500 ">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                  <tr>
                    <th scope="col" className="py-2 px-3 text-center">
                      סטטוס
                    </th>
                    <th scope="col" className="py-2 px-3 text-center">
                      מדינה
                    </th>
                    <th scope="col" className="py-2 px-3 text-center">
                      יעד
                    </th>
                    <th scope="col" className="py-2 px-3 text-center">
                      מס טיסה
                    </th>
                    {/* <th scope="col" className="py-2 px-3">
                טרמינל
                </th> */}
                    <th scope="col" className="py-2 px-3 text-center">
                      זמן
                    </th>
                  </tr>
                </thead>
                <tbody>

                  {flights?.map(f => (
                    <tr key={f.RecordNumber} className="bg-white border-b ">
                      <th scope="row" className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap  text-right">
                        {f.Remarks}
                      </th>
                      <td className="py-2 px3 text-center">
                        {f.Country}
                      </td>
                      <td className="py-2 px-3 text-center">
                        {f.Town}
                      </td>
                      <td className="py-2 px-3 text-center">
                        {/* {f.seats} */}
                        <br />
                        {/* <a href={`https://eo844g9vta6oqlq.m.pipedream.net/?flightNumber=${f.FlightNumber.replace(' ','')}`} target="_blank">{f.FlightNumber}</a> */}
                        {f.FlightNumber}
                      </td>
                      {/* <td className="py-2 px-3">
                  {f.Terminal}
                </td> */}
                      <td className="py-2 px-3 text-center">
                        {moment(new Date(f.Time)).format('HH:mm DD/MM/YYYY')}
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table></div>)}
        </div>

        {/* {cache.current?.length} */}
        <div class="text-xxs tracking-wide leading-7 text-center mt-20" style={{ fontSize: '10px' }}>
          Powered by knowledge, code & design: <a href="https://github.com/send2moran" target="_blank">send2moran</a>
        </div>
      </div>
    </div>
  );
}
